enum ValuerStatusEnum {
    Cancelled = 'CANCELLED',
    New = 'NEW',
    QuoteReceived = 'QUOTE_RECEIVED',
    QuoteRequested = 'QUOTE_REQUESTED',
    Refused = 'REFUSED',
    ValuationOrdered = 'VALUATION_ORDERED',
    ValuationReceived = 'VALUATION_RECEIVED',
}

export default ValuerStatusEnum;
